import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["initalAudience", "hasTeamsToRemove", "audienceAndTeams", "autoShare", "resetAudiencesAndTeams", "onChangeAudience", "onChangeTeams"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import useUniqueId from 'hooks/useUniqueId';
import toArray from 'utils/toArray';
import config from 'utils/config';
import FormField, { FormFieldAlignedContent } from 'components/FormField';
import Stack from 'components/Stack';
import RadioButtonOption from 'components/RadioButtonOption';
import ShadedCard from 'components/ShadedCard';
import Button from 'components/Button';
import Text from 'components/Text';
import Hint from 'components/Hint';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import { TeamPill } from 'components/Pill';
import Status from 'components/Status';
import TeamPickerModal from 'screens/TeamPickerModal';
import TeamsList from './common/TeamsList';
import { getCommonAudience, getCommonTeams, getIndeterminateTeams } from '../utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function TeamDropDown(_ref) {
  var autoShareTeams = _ref.autoShareTeams,
    children = _ref.children;
  var listItems = autoShareTeams.flat().map(function (team) {
    return /*#__PURE__*/_jsx(TeamPill, {
      team: team
    }, team.name);
  });
  return /*#__PURE__*/_jsx(DetailsDropdown, {
    titleKey: "property_auto_share_audience_teams",
    listItems: listItems,
    children: children
  });
}
function getAutoShareHint(_ref2) {
  var audience = _ref2.audience,
    teams = _ref2.teams,
    autoShare = _ref2.autoShare,
    hasTeamsToRemove = _ref2.hasTeamsToRemove;
  if (!config.autoSharing || audience === 'mixed' || audience === 'all') return;
  var isMultiSelect = autoShare.length > 1;
  var count = autoShare.length;
  var autoShareTypes = autoShare.map(function (_ref3) {
    var type = _ref3.type;
    return type;
  });
  if (audience === 'admin' && (autoShareTypes.includes('everyone') || autoShareTypes.includes('teams'))) {
    return i18n.t('hint_autoshare_disabled_by_admin_audience', {
      count: count
    });
  }
  if (audience === 'teams' && autoShareTypes.includes('everyone')) {
    return i18n.t('hint_autoshare_all_disabled_by_team_audience', {
      count: count
    });
  }
  if (isMultiSelect && audience === 'teams' && autoShareTypes.includes('teams') && hasTeamsToRemove) {
    return i18n.t('hint_autoshare_teams_disabled_by_team_audience_plural');
  }
  if (!isMultiSelect) {
    var _autoShare$ = autoShare[0],
      autoShareType = _autoShare$.type,
      autoShareTeams = _autoShare$.teams;
    if (autoShareType === 'null') return;
    var autoShareTeamIds = autoShareTeams.map(function (_ref4) {
      var id = _ref4.id;
      return id;
    });
    var teamIds = teams.flatMap(function (team) {
      return team.map(function (_ref5) {
        var id = _ref5.id;
        return id;
      });
    });
    var includesAllAutoShareTeams = autoShareTeamIds.every(function (autoShareTeamId) {
      return teamIds.includes(autoShareTeamId);
    });
    if (autoShareType === 'teams' && audience === 'teams' && !includesAllAutoShareTeams) {
      return /*#__PURE__*/_jsxs(Trans, {
        i18nKey: "hint_autoshare_teams_disabled_by_team_audience",
        children: ["The auto-share for this playlist will be disabled as the playlist is no longer shareable with all", ' ', /*#__PURE__*/_jsx(TeamDropDown, {
          autoShareTeams: autoShareTeams,
          children: "teams"
        }), ' ', "in the auto-share audience."]
      });
    }
  }
}
function PlaylistAudienceField(_ref6) {
  var initalAudience = _ref6.initalAudience,
    hasTeamsToRemove = _ref6.hasTeamsToRemove,
    audienceAndTeams = _ref6.audienceAndTeams,
    autoShare = _ref6.autoShare,
    resetAudiencesAndTeams = _ref6.resetAudiencesAndTeams,
    onChangeAudience = _ref6.onChangeAudience,
    onChangeTeams = _ref6.onChangeTeams,
    otherProps = _objectWithoutProperties(_ref6, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasTeamPickerModal = _useState2[0],
    setHasTeamPickerModal = _useState2[1];
  var allAudiences = audienceAndTeams.flat().map(function (_ref7) {
    var audience = _ref7.audience;
    return audience;
  });
  var commonAudience = getCommonAudience(allAudiences);
  var isMultiSelect = audienceAndTeams.length > 1;
  var nonhereditaryTeams = audienceAndTeams.map(function (item) {
    return (
      // Remove calculated teams and non-team items
      item.filter(function (i) {
        return !i.team.isCalculated && i.team.id !== 'null';
      })
    );
  }).map(function (item) {
    return item.map(function (i) {
      return i.team;
    });
  });
  var commonTeams = isMultiSelect ? getCommonTeams(nonhereditaryTeams) : nonhereditaryTeams[0];
  var indeterminateTeams = isMultiSelect ? getIndeterminateTeams(nonhereditaryTeams).filter(function (team) {
    return !(team !== null && team !== void 0 && team.isCalculated);
  }) : [];
  var displayedTeams = [].concat(_toConsumableArray(commonTeams), _toConsumableArray(indeterminateTeams));
  function handleAudienceChange(e) {
    var newAudience = e.currentTarget.value;
    onChangeAudience(newAudience);
  }
  var onRemoveTeam = function onRemoveTeam(toRemoveTeamId) {
    var teamsToRemove = audienceAndTeams.flat().filter(function (item) {
      return item.team.id === toRemoveTeamId;
    });
    if (teamsToRemove) {
      onChangeTeams({
        toRemove: teamsToRemove
      });
    }
  };
  var onSubmitTeams = function onSubmitTeams(_ref8) {
    var toAdd = _ref8.toAdd,
      toRemove = _ref8.toRemove;
    onChangeTeams({
      toAdd: toArray(toAdd).map(function (team) {
        return audienceAndTeams.flat().map(function (item) {
          return {
            playlistId: item.playlistId,
            audience: commonAudience || item.audience,
            team: team
          };
        });
      }).flat(),
      toRemove: toArray(toRemove).map(function (team) {
        return audienceAndTeams.flat().map(function (item) {
          return {
            playlistId: item.playlistId,
            audience: commonAudience || item.audience,
            team: team
          };
        });
      }).flat()
    });
    setHasTeamPickerModal(false);
  };
  var autoShareHint = getAutoShareHint({
    hasTeamsToRemove: hasTeamsToRemove,
    audience: commonAudience,
    teams: nonhereditaryTeams,
    autoShare: autoShare
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
        as: "span",
        label: t('property_audience'),
        labelId: uniqueId
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "xs",
          children: [isMultiSelect && initalAudience === 'mixed' && /*#__PURE__*/_jsx(RadioButtonOption, {
            checked: commonAudience === 'mixed',
            value: "mixed",
            id: "can_see_mixed_radiobttn",
            onChange: resetAudiencesAndTeams,
            label: t('state_mixed')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            checked: commonAudience === 'all',
            value: "all",
            id: "can_see_everyone_radiobttn",
            onChange: handleAudienceChange,
            label: t('state_everyone')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            checked: commonAudience === 'teams',
            value: "teams",
            id: "can_see_teams_radiobttn",
            onChange: handleAudienceChange,
            label: t('state_selected_teams')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            checked: commonAudience === 'admin',
            value: "admin",
            id: "can_see_only_admins_radiobttn",
            onChange: handleAudienceChange,
            label: t('state_only_admins')
          })]
        })
      })), commonAudience === 'teams' && /*#__PURE__*/_jsx(FormFieldAlignedContent, {
        children: /*#__PURE__*/_jsx(ShadedCard, {
          px: "s",
          py: "xs",
          children: /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
            as: "span",
            label: t('content_type_team_plural'),
            labelId: uniqueId,
            horizontal: false
          }, otherProps), {}, {
            children: /*#__PURE__*/_jsxs(Stack, {
              spacing: "xs",
              children: [displayedTeams.length === 0 ? /*#__PURE__*/_jsx(Text, {
                dimmed: true,
                size: "s",
                children: t('amount_none')
              }) : /*#__PURE__*/_jsxs(Stack, {
                spacing: "xs",
                children: [commonTeams.length > 0 && /*#__PURE__*/_jsx(TeamsList, {
                  title: isMultiSelect ? t('property_common') : undefined,
                  description: isMultiSelect ? t('hint_teams_playlist_common', {
                    count: commonTeams.length
                  }) : undefined,
                  teams: commonTeams,
                  onRemoveTeam: onRemoveTeam
                }), indeterminateTeams.length > 0 && /*#__PURE__*/_jsx(TeamsList, {
                  title: t('property_individual'),
                  description: t('hint_teams_playlist_individual', {
                    count: indeterminateTeams.length
                  }),
                  teams: indeterminateTeams,
                  onRemoveTeam: onRemoveTeam
                })]
              }), /*#__PURE__*/_jsx(Button, {
                size: "medium",
                icon: "edit",
                onClick: function onClick() {
                  return setHasTeamPickerModal(true);
                },
                children: t('actions_select_teams')
              })]
            })
          }))
        })
      })]
    }), /*#__PURE__*/_jsx(Status, {
      mt: autoShareHint ? 's' : undefined,
      children: autoShareHint && /*#__PURE__*/_jsx(FormFieldAlignedContent, {
        children: /*#__PURE__*/_jsx(Hint, {
          children: autoShareHint
        })
      })
    }), hasTeamPickerModal && /*#__PURE__*/_jsx(TeamPickerModal, {
      defaultSelectedItems: commonTeams,
      defaultIndeterminateItems: indeterminateTeams,
      onClose: function onClose() {
        return setHasTeamPickerModal(false);
      },
      onSubmit: onSubmitTeams
    })]
  });
}
export default PlaylistAudienceField;